export default (node) => {
    return {
        display: node.style.display,
        cssClasses: node.getAttribute('class')
            ? node.getAttribute('class').split(' ')
            : []
    }
}
